import DOMPurify from "dompurify";

export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html);
};

export const buildHref = (value: string): string => {
  const parsed = new URL(value, window.location.origin);
  return ["https:", "http:"].includes(parsed.protocol) ? parsed.href : "";
};
